import React, { useEffect, useState } from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useHistoryEntryTypes } from '../../../hooks/history/useHistoryEntryTypes';

export default function ProcedureSelect ({ open, onClose, onSelect }) {

    const handleClose = () => onClose();

    const {historyEntryTypes, loading} = useHistoryEntryTypes();

    const handleChange = (e) => {
      onSelect(e.target.value);
    };


    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogContent>
                <FormControl fullWidth sx={{ minHeight: 300 }}>
                  <InputLabel>
                    Select Procedure
                  </InputLabel>
                  <Select
                    value=""
                    label="Select Procedure"
                    onChange={handleChange}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // adjust as needed
                        },
                      },
                    }}
                  >
                    {!loading &&
                      historyEntryTypes
                        ?.slice() // clone to avoid mutating original
                        .sort((a, b) => {
                          const order = (name) => {
                            if (name === "Others") return 2;       // lowest priority
                            if (name === "Rare Case") return 1;    // second to last
                            return 0;                              // default priority
                          };

                          const diff = order(a.name) - order(b.name);
                          if (diff !== 0) return diff;

                          // fallback: alphabetical sort
                          return a.name.localeCompare(b.name);
                        })
                        .map((historyEntryType) => (
                          <MenuItem key={historyEntryType.id} value={historyEntryType.id} sx={{ my: 1 }}>
                            {historyEntryType.name}
                          </MenuItem>
                        ))}
                  </Select>

                </FormControl>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}